import { api } from "..";
import { MemberCard,Recharge,RecordType,TradeType,Goods } from "@/types/integral";
import { buildQueryString } from "./utils";
import { url } from "inspector";
import { ResultOk } from "@/types/resultok";


export const integralApi = api.injectEndpoints({
  endpoints: (build) => ({
    //获取会员卡
    getMemberCard:build.query<MemberCard[],string>({
      query: (prod_type) => `/wechat/products${buildQueryString({prod_type})}`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),
    //获取积分充值
    getRecharge:build.query<Recharge[],string>({
      query: (prod_type) => `/wechat/products${buildQueryString({prod_type})}`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),
    //下单
    createNativePay:build.mutation<any, Goods>({
      query:(body)=>({
        url:`/wechat/pay/transactions/native`,
        method: 'POST',
        body
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      invalidatesTags: ["Order"]
    }),
    //查询订单状态
    getOrderStatus:build.query<TradeType,string>({
      query:(order_sn)=>`/wechat/pay/orders/${order_sn}/status`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),
    //获取订单列表,订单记录，通过type区分会员卡和积分
    getOrders:build.query<TradeType[],{ page: number; per_page: number; begin_time: string; end_time: string; type: string }>({
      query:(params)=>`/wechat/pay/orders${buildQueryString(params)}`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
      providesTags:["Order"]
    }),
    // 获取积分消费详情
    getPayList:build.query<RecordType[],{ page: number; per_page: number; begin_time: string; end_time: string;}>({
      query:(params)=>`/payment${buildQueryString(params)}`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),
    createPay:build.mutation<ResultOk,RecordType>({
      query:(payment)=>({
        url:`/payment`,
        method: 'POST',
        body:payment
      }),
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    })
  }),
});

export const { 
  useLazyGetMemberCardQuery,
  useLazyGetRechargeQuery,
  useCreateNativePayMutation,
  useLazyGetOrderStatusQuery,
  useLazyGetOrdersQuery,
  useLazyGetPayListQuery,
} = integralApi;
